import React from 'react';
import HeroBlock from './HeroBlock';
import StatsBlock from './StatsBlock';
import FeaturesBlock from './FeaturesBlock';
import HowItWorksBlock from './HowItWorksBlock';
import SecurityBlock from './SecurityBlock';
import CtaBlock from './CtaBlock';

const blockComponents = {
  hero: HeroBlock,
  stats: StatsBlock,
  features: FeaturesBlock,
  how_it_works: HowItWorksBlock,
  security: SecurityBlock,
  cta: CtaBlock,
};

const BlockRenderer = ({ blocks = [] }) => {
  return (
    <>
      {blocks
        .filter((block) => block.enabled)
        .map((block) => {
          const Component = blockComponents[block.type];
          if (!Component) return null;
          return <Component key={block.id} data={block.data} />;
        })}
    </>
  );
};

export default BlockRenderer;
